window.addEventListener("load", function (event) {
    const formFeedback = document.querySelector("[data-feedback]");
    if (formFeedback) {
        const container = document.querySelector("[data-notification='container']");
        const modal = document.querySelector("[data-notification='modal']");
        const title = modal.querySelector("[data-notification='title']");
        const message = modal.querySelector("[data-notification='message']");
        title.textContent = formFeedback.dataset.title;
        message.textContent = formFeedback.dataset.message;
        modal.parentElement.classList.replace("dn", "flex");

        formFeedback.parentElement.removeChild(formFeedback);

        const closeModal = modal.querySelector("[data-notification='close']");
        closeModal.addEventListener("click", function (ev) {
            modal.parentElement.classList.replace("flex", "dn");
            modal.parentElement.removeChild(modal);
        });
    }
});
